import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { PageContent } from 'components/quote/add-employees/full-employee-form';
import { useFullEmployeeFormUrlParams } from 'global/hooks/useEmployeeFullFormUrlParams';
import FullFormPageStore, { FullFormPageStoreContext } from 'store/pages/quote/add-employees/full-form/pageStore';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';

/** TESTING_POLICY: CYPRESS_ONLY */

const FullFormPage: React.FC = observer(() => {
  const { periodId, groupId, subscriberId, activeTabId } = useFullEmployeeFormUrlParams();
  const { cartId } = useQuoteDomainParams();

  // Keep one store instance for this group/period/cart. Do not depend on subscriberId or
  // activeTabId: clearing those query params (e.g. Add Another Employee) would recreate the
  // store, re-run getInitialData, and race with the in-flight reset — flickering UI and a stuck loader.
  const store = useMemo(
    () => new FullFormPageStore({ groupId, periodId, cartId, subscriberId, activeTabId }),
    [groupId, periodId, cartId],
  );

  return (
    <FullFormPageStoreContext.Provider value={store}>
      <PageContent />
    </FullFormPageStoreContext.Provider>
  );
});

export default FullFormPage;
